import React from 'react';
import Footer from '../components/Footer';

const STEPS = [
  {
    icon: '📩',
    title: 'Pasul 1 — Înregistrare firmă',
    text: 'Din pagina de conectare, apăsați pe „Înregistrare client nou" și completați datele firmei (denumire, CUI, persoană de contact). După citirea și bifarea politicii de confidențialitate și a termenilor și condițiilor, trimiteți cererea. Veți fi contactat pentru activarea contului.'
  },
  {
    icon: '🔑',
    title: 'Pasul 2 — Conectare',
    text: 'După activare, conectați-vă cu utilizatorul și parola primite. Puteți bifa „Ține minte utilizatorul" pentru a nu le mai introduce data viitoare, sau puteți încerca aplicația din contul „Demo".'
  },
  {
    icon: '🏠',
    title: 'Pasul 3 — Pagina Acasă',
    text: 'Prima pagină după conectare afișează alertele importante: documente sau revizii care urmează să expire, pentru a nu rata un termen.'
  },
  {
    icon: '🚛',
    title: 'Pasul 4 — Autovehicule',
    text: 'Din secțiunea „Autovehicule" adăugați vehiculele administrate: date tehnice, documente (ITP, RCA, rovinietă etc.) și datele lor de expirare.'
  },
  {
    icon: '📄',
    title: 'Pasul 5 — Cheltuieli',
    text: 'Înregistrați cheltuielile asociate fiecărui vehicul (asigurări, taxe, reparații etc.) pentru a avea o evidență completă a costurilor.'
  },
  {
    icon: '⛽',
    title: 'Pasul 6 — Carburant',
    text: 'Notați alimentările de carburant pentru fiecare vehicul: cantitate, cost și kilometraj, pentru a urmări consumul în timp.'
  },
  {
    icon: '🔧',
    title: 'Pasul 7 — Piese',
    text: 'Țineți evidența pieselor înlocuite la fiecare vehicul, cu dată și cost, utilă pentru istoricul de mentenanță.'
  },
  {
    icon: '🔩',
    title: 'Pasul 8 — Revizii',
    text: 'Programați și înregistrați reviziile tehnice periodice, astfel încât aplicația să vă poată alerta din timp înainte de expirare.'
  },
  {
    icon: '📊',
    title: 'Pasul 9 — Rapoarte',
    text: 'Generați rapoarte centralizate pe perioade de timp pentru a analiza costurile totale ale parcului auto sau ale unui singur vehicul.'
  },
  {
    icon: '👤',
    title: 'Pasul 10 — Contul meu',
    text: 'Din meniul contului puteți vedea și, unde este permis, modifica datele contului dumneavoastră.'
  },
];

export default function Help() {
  return (
    <div className="page-with-footer">
      <div className="page-body">
        <div className="legal-page">
          <div className="legal-box">
            <h1>❓ Ajutor — Cum se folosește aplicația</h1>
            <div className="legal-updated">Un scurt tutorial pentru primii pași în Monitorizare Flotă</div>

            <p>
              Monitorizare Flotă vă ajută să țineți evidența autovehiculelor, cheltuielilor,
              carburantului, pieselor și reviziilor firmei dumneavoastră, într-un singur loc.
              Mai jos găsiți pașii principali de utilizare.
            </p>

            <h2>Pași de utilizare</h2>
            {STEPS.map((s, i) => (
              <div className="help-step" key={i}>
                <div className="help-step-icon">{s.icon}</div>
                <div className="help-step-text">
                  <p><b>{s.title}</b><br/>{s.text}</p>
                </div>
              </div>
            ))}

            <h2>Aveți nevoie de mai mult de un utilizator sau un vehicul?</h2>
            <p>
              Aplicația este gratuită în limita unui singur utilizator și a unui singur
              autovehicul per firmă. Pentru extinderea planului, contactați-ne prin intermediul{' '}
              <a href="https://www.softconsult.ro" target="_blank" rel="noopener noreferrer">
                softconsult.ro
              </a>.
            </p>

            <h2>Alte întrebări?</h2>
            <p>
              Consultați și{' '}
              <a href="/confidentialitate">Politica de confidențialitate</a> și{' '}
              <a href="/termeni">Termenii și condițiile</a> aplicației, sau contactați-ne direct.
            </p>

            <a className="legal-back" href="/login">← Înapoi la pagina de conectare</a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
